



























































































































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'

    class AddModel {
        storeName: string;
        storeAddress: string;
        contactName: string;
        contactPhone: string;
        remark: string;
        site: number;
        whetherLocal: boolean;
        whetherNeedWeighing: boolean;
    }
    @Component
    export default class CreatemodelModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        model: AddModel = new AddModel();
        selectDate: string = "";
        selectDates: string = "";
        addLoding = false;
        siteType = Enums.SiteSType;
        whetherLocalList = Enums.WhetherLocal;
        amountTotal: string = '';;
        isShow: boolean;
        created() {

        }
        changestatus(a: any) {
            if (a == true) {
                this.isShow = false;
            }
            else {
                this.isShow = true;
            }
        }
        signFor() {
            this.save();
        }
        save() {
            (this.$refs.storeaddressCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'backstoreaddress/Edit',
                        data: this.model
                    }).finally(() => {
                        this.addLoding = false;
                    });

                    (this.$refs.storeaddressCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);

                }
            })
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        cancel() {
            (this.$refs.storeaddressCreateForm as any).resetFields();
            this.$emit('input', false);
        }

        modelRule = {
            storeName: [
                { required: true, message: '仓储名称不能为空', trigger: 'blur' }
            ],
            storeAddress: [
                { required: true, message: '仓储地址不能为空', trigger: 'blur' }
            ],
            contactName: [
                { required: true, message: '联系人不能为空', trigger: 'blur' }
            ],
            contactPhone: [
                { required: true, message: '联系电话不能为空', trigger: 'blur' }
            ],
        };

    }
